import { PROMISE_NOT_ALLOWED } from '../../message/error_message';
import { OptimizelyError } from '../../error/optimizly_error';
const isPromise = (val) => {
    return val && typeof val.then === 'function';
};
/**
 * A class that wraps a value that can be either a synchronous value or a promise and provides
 * a promise like interface. This class is used to handle both synchronous and asynchronous values
 * in a uniform way.
 */
export class Value {
    constructor(op, val) {
        this.op = op;
        this.val = val;
    }
    get() {
        return this.val;
    }
    then(fn) {
        if (this.op === 'sync') {
            const newVal = fn(this.val);
            return Value.of(this.op, newVal.get());
        }
        return Value.of(this.op, this.val.then(fn));
    }
    static of(op, val) {
        if (op === 'sync') {
            if (isPromise(val)) {
                throw new OptimizelyError(PROMISE_NOT_ALLOWED);
            }
            return new Value(op, val);
        }
        return new Value(op, Promise.resolve(val));
    }
}
Value.all = (op, vals) => {
    if (op === 'sync') {
        const values = vals.map(v => v.get());
        return Value.of(op, values);
    }
    const promises = vals.map(v => v.get());
    return Value.of(op, Promise.all(promises));
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=operation_value.js.map